/* es5-ext/math/sign/index */ function _(require, module, exports) {
    module.exports = require(331) /* ./is-implemented */()
        ? Math.sign
        : require(332) /* ./shim */;
}
